import React, { useEffect, useState, useMemo } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Box,
  useMediaQuery,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
  Collapse,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  CircularProgress,
} from "@mui/material";
import {
  Facebook,
  YouTube,
  LocationOn,
  ArrowDropDown,
  Menu as MenuIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import colors from "../../Assest/Theme/Color";
import LogoutIcon from "@mui/icons-material/Logout";
import logo from "../../Assest/Images/headerlogonew.svg";
import bgImage from "../../Assest/Images/rightHeader.svg";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import Routings from "../../Routings";
import { postData } from "../../BaseUrl";
import english from "../../Language/English.json";
import tamil from "../../Language/Tamil.json";
import InstagramIcon from "@mui/icons-material/Instagram";

const Header = () => {
  const [activeNav, setActiveNav] = useState("Home");
  const [programMenuOpen, setProgramMenuOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isTop, setIsTop] = useState(true);

  const languageSelect = sessionStorage.getItem("lng");
  const translations = languageSelect === "Tamil" ? tamil : english;
  const [lang, setLang] = useState(sessionStorage.getItem("lng") || "English");

  const toggleLang = () => {
    const next = lang === "English" ? "Tamil" : "English";
    setLang(next);
    sessionStorage.setItem("lng", next);
    window.dispatchEvent(new Event("languagechange"));
  };
  // const Header = ({ isMobile, translations, languageSelect, handleNavClick }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [, setUserName] = useState("");

  const handleScroll = () => {
    setIsTop(window.scrollY === 0);
  };

  useEffect(() => {
    // Add scroll event listener on mount and remove on unmount
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isMobile = useMediaQuery("(max-width:912px)");

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
  };

  const navLinks = useMemo(() => [
    { name: "home", link: Routings.HOME },
    { name: "curriculum", link: Routings.CURRICULUM },
    { name: "program", link: "/program" },
    { name: "contact", link: Routings.CONTACT_US },
    { name: "seal_of_biliteracy", link: Routings.BILITERACY },
    { name: "about_us", link: Routings.ABOUT_US },
  ], []);

  useEffect(() => {
    const currentPath = location.pathname; // e.g., "/Program/Event"
    const firstSegment = currentPath.split("/")[1]; // Extracts "Program"
    const activeLink = navLinks.find(
      (link) => firstSegment === link.link.split("/")[1]
    );
    if (activeLink) {
      setActiveNav(activeLink.name);
    }
  }, [location.pathname, navLinks]);

  const handleNavClick = (link) => {
    window.scrollTo({ top: 0, behavior: "auto" });
    setActiveNav(link.name);
    navigate(link.link);
    setDropdownOpen(false);
    closeDrawer();
  };

  const handleProgramClick = () => {
    setProgramMenuOpen((prevState) => !prevState);
  };

  const toggleDropdown = () => {
    setDropdownOpen((prevState) => !prevState);
  };
  useEffect(() => {
    // Simulate getting user data from sessionStorage/localStorage
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user) {
      setIsLoggedIn(true);
      setUserName(user.name);
    }
  }, []);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleDropdownToggle = () => {
    setIsDropdownOpen((prev) => !prev);
  };
  const [showOptions, setShowOptions] = useState(false);
  const handleLogout = () => {
    sessionStorage.removeItem("user");
    navigate("/login");
    setIsLoggedIn(false);
    setUserName("");
    setIsDropdownOpen(false);
  };

  const [registerModalOpen, setRegisterModalOpen] = useState(false);

  /* ── Existing Student Verification ── */
  const [verifyOpen, setVerifyOpen] = useState(false);
  const [verifyForm, setVerifyForm] = useState({
    registrationNumber: "",
    parentEmail1: "",
    parentEmail2: "",
  });
  const [verifyErrors, setVerifyErrors] = useState({});
  const [verifyLoading, setVerifyLoading] = useState(false);
  const [verifyApiError, setVerifyApiError] = useState("");

  const openVerifyModal = () => {
    setRegisterModalOpen(false);
    setVerifyForm({ registrationNumber: "", parentEmail1: "", parentEmail2: "" });
    setVerifyErrors({});
    setVerifyApiError("");
    setVerifyOpen(true);
  };

  const handleVerifyChange = (field) => (e) => {
    setVerifyForm((prev) => ({ ...prev, [field]: e.target.value }));
    if (verifyErrors[field]) setVerifyErrors((prev) => ({ ...prev, [field]: "" }));
    if (verifyApiError) setVerifyApiError("");
  };

  const validateVerify = () => {
    const errs = {};
    if (!verifyForm.registrationNumber.trim())
      errs.registrationNumber = "Student Registration Number is required";
    if (!verifyForm.parentEmail1.trim())
      errs.parentEmail1 = "Parent Email ID – 1 is required";
    else if (!/\S+@\S+\.\S+/.test(verifyForm.parentEmail1))
      errs.parentEmail1 = "Enter a valid email address";
    if (!verifyForm.parentEmail2.trim())
      errs.parentEmail2 = "Parent Email ID – 2 is required";
    else if (!/\S+@\S+\.\S+/.test(verifyForm.parentEmail2))
      errs.parentEmail2 = "Enter a valid email address";
    return errs;
  };

  const handleVerifySubmit = async () => {
    const errs = validateVerify();
    if (Object.keys(errs).length) { setVerifyErrors(errs); return; }

    setVerifyLoading(true);
    setVerifyApiError("");
    try {
      const res = await postData("student/registration/verify-existing", {
        registrationNumber: verifyForm.registrationNumber.trim(),
        parentEmail1: verifyForm.parentEmail1.trim(),
        parentEmail2: verifyForm.parentEmail2.trim(),
      });

      setVerifyOpen(false);
      // Navigate to registration pre-filled with the verified registration number
      navigate(Routings.STUDENT_REGISTRATION, {
        state: {
          existingStudent: true,
          registrationNumber: verifyForm.registrationNumber.trim(),
          studentData: res?.data || null,
        },
      });
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || "";
      setVerifyApiError(
        msg || "Verification failed. Please check your details and try again."
      );
    }
    setVerifyLoading(false);
  };

  const handleRedirect = () => {
    if (location.pathname === Routings.STUDENT_REGISTRATION) {
      setRegisterModalOpen(false);
    } else {
      setRegisterModalOpen(true);
    }
  };

  const handleredirecturl = (url) => {
    window.open(url, "_blank")
  }


  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: colors.primary,
        marginBottom: 3,
        zIndex: 99999999,
      }}
    >
      {/* Top Bar */}
      <Box
        display={!isTop ? "none" : isMobile ? "none" : "flex"}
        justifyContent="space-between"
        alignItems="center"
        sx={{ p: "0 3rem 1px 0", backgroundColor: colors.primary }}
      >
        <Box display="flex" alignItems="center" gap={3}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={1}
            sx={{
              background: `url(${bgImage})`,
              backgroundRepeat: "no-repeat",
              width: "300px",
            }}
          >
            <IconButton size="small" onClick={() => handleredirecturl(colors.Facebookurl)}>
              <Facebook sx={{ color: colors.primary }} />
            </IconButton>
            <IconButton size="small" onClick={() => handleredirecturl(colors.YouTubeurl)}>
              <YouTube sx={{ color: colors.primary }} />
            </IconButton>
            {/* <IconButton size="small" onClick={()=>handleredirecturl(colors.linkedinurl)}>
              <LinkedIn sx={{ color: colors.primary }} />
            </IconButton> */}
            {/* <IconButton size="small" onClick={()=>handleredirecturl(colors.Twitterurl)}>
              <XIcon sx={{ color: colors.primary }} />
            </IconButton> */}
            <IconButton size="small" onClick={() => handleredirecturl(colors.instaurl)}>
              <InstagramIcon sx={{ color: colors.primary }} />
            </IconButton>
          </Box>
          <div>
            <Typography
              sx={{ fontSize: languageSelect === "Tamil" ? "12px" : "14px" }}
              color="inherit"
            >
              {/* {translations.mon_to_sat} */}
              Every Friday 6:30pm — 8:00pm
            </Typography>
          </div>
        </Box>
        <Box display="flex" alignItems="center" gap={1}>
          <LocationOn fontSize="small" />
          <Typography
            sx={{ fontSize: languageSelect === "Tamil" ? "12px" : "14px" }}
            color="inherit"
          >
            <a style={{ textDecoration: 'none', color: '#fff', cursor: 'pointer' }} href="https://www.google.com/maps?q=Big+Creek+Elementary+School,+1994+Peachtree+Pkwy,+Cumming,+GA+30041" target="_blank" rel="noreferrer">
              {translations.location}
            </a>
          </Typography>
        </Box>
      </Box>

      {/* Main Header */}
      <Toolbar sx={{ backgroundColor: colors.white, color: colors.textDark }}>
        {/* Logo */}
        <Typography
          sx={{
            flexGrow: 1,
            // flexGrow: 0.6,
            display: "flex",
            alignItems: "center",
            fontSize: "20px",
            fontWeight: "bold",
            cursor: "pointer",
            color: colors.black,
          }}
          onClick={() => {
            navigate("/");
          }}
        >
          <img
            src={logo} // Replace with your logo URL
            alt="Logo"
            style={{ marginRight: 8 }}
          />
          {/* Cumming */}
        </Typography>

        <Box
          sx={{ fontSize: languageSelect === "Tamil" ? "14px" : "16px" }}
          display={isMobile ? "none" : "flex"}
          gap={2}
          component="nav"
        >
          {navLinks.map((link) =>
            link.name === "program" ? (
              <div style={{ position: "relative" }}>
                <p
                  key={link.name}
                  onClick={toggleDropdown}
                  style={{
                    cursor: "pointer",
                    color:
                      activeNav === link.name
                        ? colors.secondary
                        : colors.navColor,
                    textTransform: "none",
                    display: "flex",
                    alignItems: "center",
                    margin: 0,
                    padding: "0 15px ",
                  }}
                >
                  {translations[link.name]}{" "}
                  {dropdownOpen ? <ArrowDropUpIcon /> : <ArrowDropDown />}
                </p>
                {/* <Collapse
                  sx={{ position: "absolute", top: 1, cursor: "pointer" }}
                  in={dropdownOpen}
                  timeout="auto"
                  unmountOnExit
                >
                  <List
                    sx={{
                      position: "absolute",
                      backgroundColor: colors.white,
                      boxShadow: 3,
                      marginTop: "40px",
                      color:'#000'
                    }}
                  >
                    <ListItem
                      button
                      onClick={() =>
                        handleNavClick({
                          name: "Program",
                          link: Routings.PROGRAM_EVENT,
                        })
                      }
                      sx={{
                        color:'#000',
                        padding:'2%',
                        // paddingLeft:'1.5vw',
                        "&:hover": {
                          color: colors.secondary,
                          // background:'none'
                        },
                      }}
                    >
                      <ListItemText
                        sx={{
                          "& .MuiTypography-root": {
                            fontSize:
                              languageSelect === "Tamil" ? "14px" : "16px",
                          },
                        }}
                        primary={translations.event}
                      />
                    </ListItem>
                    <ListItem
                      sx={{
                        color:'#000',
                        padding:'2%',
                        // paddingLeft:'1.5vw',
                        "&:hover": {
                          color: colors.secondary,
                          // background:'none'
                        },
                      }}
                      button
                      onClick={() =>
                        handleNavClick({
                          name: "Program",
                          link: Routings.PROGRAM_CALENDAR,
                        })
                      }
                    >
                      <ListItemText
                        sx={{
                          "& .MuiTypography-root": {
                            fontSize:
                              languageSelect === "Tamil" ? "14px" : "16px",
                          },
                        }}
                        primary={translations.calendar}
                      />
                    </ListItem>
                  </List>
                </Collapse> */}
                <Collapse
                  sx={{ position: "absolute", top: 5, cursor: "pointer" }}
                  in={dropdownOpen}
                  timeout="auto"
                  unmountOnExit
                >
                  <List
                    sx={{
                      position: "absolute",
                      backgroundColor: colors.white,
                      boxShadow: 3,
                      marginTop: "40px",
                    }}
                  >
                    <ListItem
                      button
                      onClick={() =>
                        handleNavClick({
                          name: "Program",
                          link: Routings.PROGRAM_EVENT,
                        })
                      }
                      sx={{
                        color: colors.black,
                        "&:hover": {
                          color: colors.secondary,
                        },
                      }}
                    >
                      <ListItemText
                        sx={{
                          "& .MuiTypography-root": {
                            fontSize:
                              languageSelect === "Tamil" ? "14px" : "16px",
                          },
                        }}
                        primary={translations.event}
                      />
                    </ListItem>
                    <ListItem
                      sx={{
                        color: colors.black,
                        "&:hover": {
                          color: colors.secondary,
                        },
                      }}
                      button
                      onClick={() =>
                        handleNavClick({
                          name: "Program",
                          link: Routings.PROGRAM_CALENDAR,
                        })
                      }
                    >
                      <ListItemText
                        sx={{
                          "& .MuiTypography-root": {
                            fontSize:
                              languageSelect === "Tamil" ? "14px" : "16px",
                          },
                        }}
                        primary={translations.calendar}
                      />
                    </ListItem>
                  </List>
                </Collapse>
              </div>
            ) : (
              <p
                key={link.name}
                onClick={() => handleNavClick(link)}
                style={{
                  cursor: "pointer",
                  color:
                    activeNav === link.name
                      ? colors.secondary
                      : colors.navColor,
                  textTransform: "none",
                  margin: 0,
                  padding: "0 15px ",
                }}
              >
                {translations[link.name]}
              </p>
            )
          )}
        </Box>

        <Box display={isMobile ? "none" : "flex"} gap={2} alignItems="center">
          {isLoggedIn ? (
            <>
              <Button
                onClick={() =>
                  handleNavClick({ name: "Login", link: Routings.LOGIN })
                }
                sx={{
                  textTransform: "capitalize",
                  color: colors.black,
                  fontWeight: "bold",
                  fontSize: languageSelect === "Tamil" ? "12px" : "14px",
                }}
              >
                {translations.login}
              </Button>
              <Button
                // onClick={() =>
                //   handleNavClick({ name: "Register", link: Routings.REGISTER })
                // }
                onClick={handleRedirect}
                variant="contained"
                sx={{
                  backgroundColor: colors.regButton,
                  color: colors.textLight,
                  textTransform: "capitalize",
                  borderRadius: "12px",
                  fontSize: languageSelect === "Tamil" ? "12px" : "14px",
                }}
              >
                {translations.register}
              </Button>
            </>
          ) : (
            <Box display="flex" alignItems="center" gap={1} position="relative">
              <Avatar
                alt="Abi"
                src="/static/images/avatar/1.jpg"
                onClick={handleDropdownToggle} // Changed function name
                sx={{ cursor: "pointer" }}
              />
              {isDropdownOpen && (
                <Box
                  position="absolute"
                  top={50} // Adjust vertical position slightly below the avatar
                  right="-90%" // Center horizontally
                  bgcolor="white"
                  width={"100px"}
                  boxShadow={3}
                  p={3}
                  borderRadius={2}
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  gap={2}
                //  transform="translateX(-90%)" // Centers the box perfectly
                >
                  <Box display="flex" alignItems="center" gap={0.5}>
                    <Avatar alt="Abi" src="/static/images/avatar/1.jpg" />
                    <Typography fontWeight="bold" color={colors.black}>
                      Abi
                    </Typography>
                  </Box>

                  <Button
                    onClick={handleLogout}
                    sx={{
                      textTransform: "capitalize",
                      color: colors.black,
                      fontWeight: "bold",
                    }}
                  >
                    <LogoutIcon fontSize="small" />
                    Logout
                  </Button>
                </Box>
              )}
            </Box>
          )}
          <div style={{ position: "relative", cursor: "pointer" }}>
            <button
              onClick={toggleLang}
              style={{
                border: `1px solid ${colors.secondary}`,
                borderRadius: "16px",
                padding: "4px 14px",
                cursor: "pointer",
                fontSize: "13px",
                fontWeight: 600,
                fontFamily: "'Noto Sans Tamil', 'Latha', system-ui, sans-serif",
                backgroundColor: lang === "Tamil" ? colors.secondary : "#fff",
                color: lang === "Tamil" ? "#fff" : colors.secondary,
                transition: "all 0.2s",
              }}
            >
              {lang === "English" ? "தமிழ்" : "EN"}
            </button>
            <Collapse
              sx={{
                position: "absolute",
                top: 0,
                left: "-3.5rem",
                cursor: "pointer",
              }}
              in={showOptions}
              timeout="auto"
              unmountOnExit
            >
              <List
                sx={{
                  position: "absolute",
                  backgroundColor: colors.white,
                  boxShadow: 3,
                  marginTop: "40px",
                }}
              >
                <ListItem
                  button
                  onClick={() => {
                    setShowOptions(!showOptions);
                    sessionStorage.setItem("lng", "Tamil");
                    // setLanguage("Tamil");
                  }}
                  sx={{ padding: "0 8px" }}
                >
                  <ListItemText
                    sx={{
                      color:
                        languageSelect === "Tamil"
                          ? colors.white
                          : colors.black,
                      px: 2,
                      py: 1,
                      m: 0,
                      borderRadius: "10px",
                      backgroundColor:
                        languageSelect === "Tamil"
                          ? colors.secondary
                          : "transparent",
                      "&:hover": {
                        color:
                          languageSelect === "Tamil"
                            ? colors.white
                            : colors.secondary,
                      },
                    }}
                    primary="தமிழ்"
                  />
                </ListItem>
                <ListItem
                  sx={{ padding: "0 8px" }}
                  button
                  onClick={() => {
                    setShowOptions(!showOptions);
                    sessionStorage.setItem("lng", "English");
                  }}
                >
                  <ListItemText
                    sx={{
                      color:
                        languageSelect === "English"
                          ? colors.white
                          : colors.black,
                      px: 2,
                      py: 1,
                      m: 0,
                      borderRadius: "10px",
                      backgroundColor:
                        languageSelect === "English"
                          ? colors.secondary
                          : "transparent",
                      "&:hover": {
                        color:
                          languageSelect === "English"
                            ? colors.white
                            : colors.secondary,
                      },
                    }}
                    primary="English"
                  />
                </ListItem>
              </List>
            </Collapse>
          </div>
        </Box>

        {isMobile && (
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <button
              onClick={toggleLang}
              style={{
                border: `1px solid ${colors.secondary}`,
                borderRadius: "16px",
                padding: "4px 10px",
                cursor: "pointer",
                fontSize: "12px",
                fontWeight: 600,
                fontFamily: "'Noto Sans Tamil', 'Latha', system-ui, sans-serif",
                backgroundColor: lang === "Tamil" ? colors.secondary : "#fff",
                color: lang === "Tamil" ? "#fff" : colors.secondary,
                transition: "all 0.2s",
              }}
            >
              {lang === "English" ? "தமிழ்" : "EN"}
            </button>
            <div style={{ position: "relative", cursor: "pointer" }}>
              {/* <img
                width={isMobile ? "20" : "30"}
                height={isMobile ? "20" : "30"}
                src="https://img.icons8.com/office/40/translation.png"
                alt="translation"
                style={{ marginBottom: isMobile ? "-13px" : "-15px" }}
                onClick={() => setShowOptions(!showOptions)}
              /> */}
              <Collapse
                sx={{
                  position: "absolute",
                  top: 0,
                  left: "-3.5rem",
                  cursor: "pointer",
                }}
                in={showOptions}
                timeout="auto"
                unmountOnExit
              >
                <List
                  sx={{
                    position: "absolute",
                    backgroundColor: colors.white,
                    boxShadow: 3,
                    marginTop: "40px",
                  }}
                >
                  <ListItem
                    button
                    onClick={() => {
                      setShowOptions(!showOptions);
                      sessionStorage.setItem("lng", "Tamil");
                      // setLanguage("Tamil");
                    }}
                    sx={{ padding: "0 8px" }}
                  >
                    <ListItemText
                      sx={{
                        color:
                          languageSelect === "Tamil"
                            ? colors.white
                            : colors.black,
                        px: 2,
                        py: 1,
                        m: 0,
                        borderRadius: "10px",
                        backgroundColor:
                          languageSelect === "Tamil"
                            ? colors.secondary
                            : "transparent",
                        "&:hover": {
                          color:
                            languageSelect === "Tamil"
                              ? colors.white
                              : colors.secondary,
                        },
                      }}
                      primary="தமிழ்"
                    />
                  </ListItem>
                  <ListItem
                    sx={{ padding: "0 8px" }}
                    button
                    onClick={() => {
                      setShowOptions(!showOptions);
                      sessionStorage.setItem("lng", "English");
                    }}
                  >
                    <ListItemText
                      sx={{
                        color:
                          languageSelect === "English"
                            ? colors.white
                            : colors.black,
                        px: 2,
                        py: 1,
                        m: 0,
                        borderRadius: "10px",
                        backgroundColor:
                          languageSelect === "English"
                            ? colors.secondary
                            : "transparent",
                        "&:hover": {
                          color:
                            languageSelect === "English"
                              ? colors.white
                              : colors.secondary,
                        },
                      }}
                      primary="English"
                    />
                  </ListItem>
                </List>
              </Collapse>
            </div>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={() => toggleDrawer()}
            >
              <MenuIcon sx={{ color: colors.black }} />
            </IconButton>
          </div>
        )}
      </Toolbar>

      <Drawer anchor="left" open={drawerOpen} onClose={closeDrawer}>
        <Box sx={{ width: 250 }}>
          {/* Close Icon */}
          <Box display="flex" justifyContent="flex-end" p={2}>
            <IconButton onClick={closeDrawer}>
              <CloseIcon />
            </IconButton>
          </Box>
          <List>
            {navLinks.map((link) =>
              link.name === "program" ? (
                <React.Fragment key={link.name}>
                  <ListItem button onClick={handleProgramClick}>
                    <ListItemText primary={translations[link.name]} />
                    <ArrowDropDown />
                  </ListItem>
                  <Collapse in={programMenuOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ListItem
                        button
                        onClick={() =>
                          handleNavClick({
                            name: "Event",
                            link: Routings.PROGRAM_EVENT,
                          })
                        }
                      >
                        <ListItemText
                          primary={translations.event}
                          sx={{ pl: 4 }}
                        />
                      </ListItem>
                      <ListItem
                        button
                        onClick={() =>
                          handleNavClick({
                            name: "Calendar",
                            link: Routings.PROGRAM_CALENDAR,
                          })
                        }
                      >
                        <ListItemText
                          primary={translations.calendar}
                          sx={{ pl: 4 }}
                        />
                      </ListItem>
                    </List>
                  </Collapse>
                </React.Fragment>
              ) : (
                <ListItem
                  button
                  key={link.name}
                  onClick={() => handleNavClick(link)}
                >
                  <ListItemText primary={translations[link.name]} />
                </ListItem>
              )
            )}

            <Divider />
            <ListItem button>
              <ListItemText
                primary="Login"
                onClick={() =>
                  handleNavClick({ name: "Login", link: Routings.LOGIN })
                }
              />
            </ListItem>
            <ListItem button>
              <ListItemText
                primary="Register Now"
                // onClick={() =>
                //   handleNavClick({ name: "Register", link: Routings.REGISTER })
                // }
                onClick={handleRedirect}
              />
            </ListItem>
          </List>
        </Box>
      </Drawer>
      {/* New / Existing Student Modal */}
      <Dialog
        open={registerModalOpen}
        onClose={() => setRegisterModalOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px", p: 1 } }}
      >
        <IconButton
          onClick={() => setRegisterModalOpen(false)}
          sx={{ position: "absolute", top: 8, right: 8, color: "#9CA3AF" }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle sx={{ textAlign: "center", fontWeight: 700, fontSize: "20px", color: "#3B4E8C", pt: 4, lineHeight: 1.4 }}>
          Are you a new student<br />or an existing student?
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ textAlign: "center", color: "#6B7280", fontSize: "14px" }}>
            Please select an option to continue your registration.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", gap: 2, pb: 3, px: 3 }}>
          <Button
            variant="contained"
            onClick={() => {
              setRegisterModalOpen(false);
              navigate(Routings.STUDENT_REGISTRATION, {
                state: { studentType: "new" },
              });
            }}
            sx={{
              backgroundColor: "#3B4E8C",
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              px: 3,
              "&:hover": { backgroundColor: "#2d3d6e" },
            }}
          >
            New Student
          </Button>

          <Button
            variant="outlined"
            onClick={() => {
              setRegisterModalOpen(false);
              navigate(Routings.STUDENT_REGISTRATION, {
                state: { studentType: "old" },
              });
            }}
            sx={{
              borderColor: "#3B4E8C",
              color: "#3B4E8C",
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              px: 3,
              "&:hover": { backgroundColor: "#f0f2f8" },
            }}
          >
            Existing Student
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Existing Student Verification Modal ── */}
      <Dialog
        open={verifyOpen}
        onClose={() => !verifyLoading && setVerifyOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px", p: 1 } }}
      >
        <IconButton
          onClick={() => setVerifyOpen(false)}
          disabled={verifyLoading}
          sx={{ position: "absolute", top: 8, right: 8, color: "#9CA3AF" }}
        >
          <CloseIcon />
        </IconButton>

        <DialogTitle sx={{ textAlign: "center", fontWeight: 700, fontSize: "20px", color: "#3B4E8C", pt: 4, pb: 1 }}>
          Existing Student Verification
        </DialogTitle>

        <DialogContent sx={{ pt: 1 }}>
          <Typography sx={{ textAlign: "center", color: "#6B7280", fontSize: "14px", mb: 3 }}>
            Please enter the following details to proceed:
          </Typography>

          {/* Registration Number */}
          <Box sx={{ mb: 2.5 }}>
            <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#374151", mb: 0.8 }}>
              Student Registration Number <span style={{ color: "#f44336" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              size="small"
              placeholder="Enter Student Registration Number"
              value={verifyForm.registrationNumber}
              onChange={handleVerifyChange("registrationNumber")}
              error={!!verifyErrors.registrationNumber}
              helperText={verifyErrors.registrationNumber}
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
            />
          </Box>

          {/* Parent Email 1 */}
          <Box sx={{ mb: 2.5 }}>
            <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#374151", mb: 0.8 }}>
              Registered Parent Email ID – 1 <span style={{ color: "#f44336" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              size="small"
              type="email"
              placeholder="Enter Registered Parent Email ID – 1"
              value={verifyForm.parentEmail1}
              onChange={handleVerifyChange("parentEmail1")}
              error={!!verifyErrors.parentEmail1}
              helperText={verifyErrors.parentEmail1}
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
            />
          </Box>

          {/* Parent Email 2 */}
          <Box sx={{ mb: 1 }}>
            <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#374151", mb: 0.8 }}>
              Registered Parent Email ID – 2 <span style={{ color: "#f44336" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              size="small"
              type="email"
              placeholder="Enter Registered Parent Email ID – 2"
              value={verifyForm.parentEmail2}
              onChange={handleVerifyChange("parentEmail2")}
              error={!!verifyErrors.parentEmail2}
              helperText={verifyErrors.parentEmail2}
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
            />
          </Box>

          {/* API error */}
          {verifyApiError && (
            <Typography sx={{ fontSize: "13px", color: "#f44336", mt: 1.5, textAlign: "center" }}>
              {verifyApiError}
            </Typography>
          )}
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", gap: 2, pb: 3, px: 3 }}>
          <Button
            variant="contained"
            onClick={handleVerifySubmit}
            disabled={verifyLoading}
            sx={{
              backgroundColor: "#3B4E8C",
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              px: 4,
              minWidth: 110,
              "&:hover": { backgroundColor: "#2d3d6e" },
            }}
          >
            {verifyLoading ? <CircularProgress size={18} sx={{ color: "#fff" }} /> : "Submit"}
          </Button>
          <Button
            variant="outlined"
            onClick={() => setVerifyOpen(false)}
            disabled={verifyLoading}
            sx={{
              borderColor: "#3B4E8C",
              color: "#3B4E8C",
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              px: 4,
              "&:hover": { backgroundColor: "#f0f2f8" },
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

    </AppBar>
  );
};

export default Header;
